'use client';

import InfinityScroll from 'components/v2/molecules/infinity-scroll';
import { ForumCommentType } from 'service/forum';

import ForumCommentItem from './forum-comment-item';

interface ForumReplyListPropsType {
  replies: ForumCommentType[];
  profileUserId: number;
  profileUsername: string;
  onDelete: (commentId: number) => void;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isError: boolean;
}

const ForumReplyList = ({
  replies,
  profileUserId,
  profileUsername,
  onDelete,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isError,
}: ForumReplyListPropsType) => {
  if (replies.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-base font-semibold text-pp-text-secondary">
        返信一覧
      </h2>
      <InfinityScroll
        fetchNextPage={fetchNextPage}
        isLoading={isFetchingNextPage}
        hasNextPage={hasNextPage}
        isError={isError}
        className="!h-auto !overflow-visible"
      >
        <div className="space-y-4">
          {replies.map((reply) =>
            reply?.id ? (
              <ForumCommentItem
                key={reply.id}
                comment={reply}
                profileUserId={profileUserId}
                profileUsername={profileUsername}
                onDelete={onDelete}
                isReply
              />
            ) : null,
          )}
        </div>
      </InfinityScroll>
    </div>
  );
};

export default ForumReplyList;
